import React from "react";
import "../css/Modal.css";

const Modal = ({ isOpen, onClose, children, disableClose = false }) => {
  if (!isOpen) return null;

  const handleClose = () => {
    if (!disableClose && onClose) onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {onClose && (
          <button
            className="modal-close"
            onClick={handleClose}
            disabled={disableClose}
            aria-hidden={disableClose}
          >
            &times;
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
